<script lang="ts" setup>
import type { SizeVariants } from '~kui/types/kui';

import { Icon } from '~ds/components/ui/icon';
import { ICONS } from '~ds/lib/icons';

interface Props {
  active?: boolean;
  disabled?: boolean;
  ariaLabel?: string;
  /** Reports the state as `aria-pressed` — only for a caller whose label reads the same in both states. */
  announcePressed?: boolean;
  size?: Extract<SizeVariants, 'sm' | 'md'>;
}

const props = withDefaults(defineProps<Props>(), {
  active: false,
  disabled: false,
  ariaLabel: undefined,
  announcePressed: false,
});

const variantClasses = computed(() => {
  return twMerge(
    cva('flex size-10 shrink-0 items-center justify-center rounded-full  transition-all duration-300', {
      variants: {
        active: {
          true: 'bg-destructive',
          false: 'bg-input',
        },
        size: {
          sm: 'size-6 p-1',
          md: 'size-10 p-2',
        },
      },
    })({
      active: props.active,
      size: props.size,
    }),
  );
});
</script>

<template>
  <KUICoreClickable
    :class="variantClasses"
    :disabled="disabled"
    :aria-label="ariaLabel"
    :aria-pressed="announcePressed ? active : undefined"
  >
    <Icon
      class="text-white"
      :name="ICONS.favouriteSolid"
      size="lg"
    />
  </KUICoreClickable>
</template>
